// Comprehensive shim for zustand shallow imports
// Handle all possible import patterns from different zustand versions

// Try to import from the actual zustand shallow module
let shallow: any;
let useShallow: any;

try {
  const zustandShallow = require("zustand/esm/shallow");
  shallow = zustandShallow.shallow || zustandShallow.default;
  useShallow = shallow;
} catch {
  // Fallback implementation
  shallow = (objA: any, objB: any) => {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for (const key of keysA) {
      if (!Object.prototype.hasOwnProperty.call(objB, key) || !Object.is(objA[key], objB[key])) {
        return false;
      }
    }
    return true;
  };
  useShallow = shallow;
}

export { shallow, useShallow };
export default shallow;
